export default __webpack_public_path__ + "static/media/VK_Logo_1.86b72276.svg";